import { useAppDispatch } from "store";

import { Icon } from "rsuite";

import { useLoginMutation, useResetPasswordMutation } from "_services/auth";

import { Formik, Field, Form } from "formik";
import * as Yup from "yup";

import "./style.css";

import { useNavigate, useParams } from "react-router";

import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

import { useState } from "react";
import { authSetToken } from "_utils/slices/authSlice";

import { useTranslation, Trans } from "react-i18next";


export default () => {
  const dispatch = useAppDispatch();

  const [resetPassword] = useResetPasswordMutation();

  const [login, { isLoginError }] = useLoginMutation();

  const sendGTM = useGTMDispatch();

  const [isError, setIsError] = useState(false);
  let { token } = useParams();


  const navigate = useNavigate();

  const { t, i18n } = useTranslation();

  return (
    <div className="login bg-gradient-blue">
      <div className="reset-password-card">
        <div className="login-card-header">{t('reset-password')}</div>
        <div className="reset-password-card-form">
          <Formik
            initialValues={{
              newPass: "",
              newPassRepeat: "",
            }}
            onSubmit={async (values) => {
              if (values.newPass == values.newPassRepeat) {
                await resetPassword({ token, new_password: values.newPass });
                if (!isLoginError) {
                  sendGTM({ event: "loginDone", value: { method: "classic" } });
                }
                navigate('/app');
              }
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <Field
                  id="newPass"
                  name="newPass"
                  placeholder={t('new-password')}
                  type="password"
                />
                <Field
                  id="newPassRepeat"
                  type="password"
                  name="newPassRepeat"
                  placeholder={t('repeat-new-password')}
                />
                {isError ? (
                  <div className="form-validation-error">
                    {t('not-same-password')}
                  </div>
                ) : null}
                <div className="reset-password-card-form-buttons">
                  <button
                    className="reset-password-card-form-submit-button"
                    type="submit"
                  >
                    {t('validate')}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
